import React, { useEffect, useRef, useState } from 'react'
import {
  finalImagePath,
  getCertsImagePath,
  getCoverImagePath,
  getPlasticActiveStatus,
  getPlasticCardImagePath,
} from '../../services/utilities'
import { Swiper } from 'antd-mobile-v5'
import { DownOutline, UpOutline } from 'antd-mobile-icons'
import { useGetAllCardsImg } from '../../services/hooks'
import { isFaceEquippable } from '../common/utils'
import CardStatusBtn from './CardStatusBtn'
import MainlandCardImageShow from '../CertShow/MainlandCertShow'

import styles from './CertShowWrapper.module.css'

const MainlandCertShowWrapper = ({ cert, setCurrentCardDetail, currentCardDetail, hasChangeRight }) => {
  const defaultCoverImg = getCoverImagePath(cert)
  const [newEcardImgs, setNewEcardImgs] = useState([])
  const [currentCoverImage, setCurrentCoverImage] = useState(defaultCoverImg)
  const [isLocked, setIsLocked] = useState(false)
  const ref = useRef(null)

  const {
    loading,
    data: allCards,
    mutate,
  } = useGetAllCardsImg(cert.encodedId, {
    onSuccess: (data) => {
      const plasticImg = {
        desc: '普通版',
        imgFile: getPlasticCardImagePath(cert),
        active: getPlasticActiveStatus(cert),
      }
      const { ecardImages, customizedImages } = data
      const newImgs = ecardImages.concat(customizedImages)
      newImgs.push(plasticImg)
      setNewEcardImgs(formatEcardImgs(newImgs))
    },
  })

  const updateResult = (result) => {
    let newAllCards = allCards
    Object.values(newAllCards).forEach((imgArr) => {
      imgArr.forEach((img) => {
        img.active = false
      })
    })
    mutate(newAllCards)
    const curCard = result ? result[0] : {}
    const { bindingId, ecardImageId } = curCard

    const copyCardImgs = JSON.parse(JSON.stringify(newEcardImgs))
    copyCardImgs.forEach((arr) => {
      arr.forEach((card) => {
        const { ecardImageId: _ecardImageId, id, desc } = card
        let condition
        if (bindingId || ecardImageId) {
          // 两个字段各比各的、且都要非空才比：否则 undefined === undefined（契约回归、或前端先于后端
          // 上线时响应里根本没有 ecardImageId 这个键）会把自定义面与本地「普通版」一起标成 active，
          // 随后取最后一个 active ⇒ 刚装备的自定义面被普通版顶掉。同口径见 reducers/index.js 的
          // updateEcardsActiveStatus 与 china-club-web 的 updateCertActiveImage。
          condition = (bindingId && bindingId === id) || (_ecardImageId && _ecardImageId === ecardImageId)
        } else {
          condition = desc === '普通版'
        }
        if (condition) {
          card.active = true
        } else {
          card.active = false
        }
      })
    })
    setNewEcardImgs(copyCardImgs)
  }

  const formatEcardImgs = (list) => {
    let newList = []
    let innerList = []
    let idx = 0
    list.forEach((img, index) => {
      innerList.push(img)
      idx++
      if (idx == 3) {
        newList.push(innerList)
        innerList = []
        idx = 0
      }
    })
    if (innerList.length) newList.push(innerList)
    return newList
  }

  const toggleCoverImg = (img, index1, index2) => {
    setCurrentCardDetail(newEcardImgs[index1][index2])
    setCurrentCoverImage(getCertsImagePath(img, cert))
  }

  const sameCoverImage = (imgItem, cert) => {
    if (imgItem.imgUrl) {
      return imgItem.imgUrl.split('?Expires')[0] === currentCoverImage.split('?Expires')[0]
    } else {
      return currentCoverImage === getCertsImagePath(imgItem, cert)
    }
  }

  useEffect(() => {
    if (currentCardDetail) {
      // 已装备的面不算「未获得」：VIP 换面集面只装备、不落所有权，level 归零后 vipAvailable=false、
      // ecardImageBindingId=null，但它此刻正装备着 ⇒ 不能再显示「您暂未获得该卡」。
      // 同口径见 CertShowWrapped.js 的 `isFaceEquippable(card) || !!card.active`。
      setIsLocked(!hasChangeRight && !currentCardDetail.id && !isFaceEquippable(currentCardDetail)
        && !currentCardDetail.active)
      if (currentCardDetail.desc === '普通版') setIsLocked(false)
    }
  }, [currentCardDetail])

  useEffect(() => {
    if (newEcardImgs.length > 0) {
      let activeItem
      newEcardImgs.forEach((arr) => {
        arr.forEach((card) => {
          if (card.active) activeItem = card
        })
      })
      setCurrentCardDetail(activeItem)
      setCurrentCoverImage(getCertsImagePath(activeItem, cert))
    }
  }, [newEcardImgs])

  if (loading) return null

  return (
    <div className={styles['cards-area']}>
      <img src={require('../../assets/images/buy_cards/card-options-area-bg.png')} alt="bg" className={styles.bg} />
      <div className={styles['cards-box']}>
        <div className={styles.left}>
          <MainlandCardImageShow
            path={currentCoverImage}
            cert={cert}
            isLocked={isLocked}
            cardImageName={currentCardDetail?.desc}
            currentYearImage={currentCardDetail?.currentYearImage}
            yearImage={currentCardDetail?.yearImage}
          />
          <CardStatusBtn
            hasChangeRight={hasChangeRight}
            path={currentCoverImage}
            imgItem={currentCardDetail}
            cert={cert}
            updateResult={updateResult}
          />
        </div>
        <div className={styles.right}>
          <div className={styles.up} onClick={() => ref.current?.swipePrev()}>
            <UpOutline fontSize={16} color="#333333" />
          </div>
          <Swiper direction="vertical" indicator={false} ref={ref}>
            {newEcardImgs.map((item, index1) => (
              <Swiper.Item key={index1} className={styles.album}>
                <div className={styles['img-box']}>
                  {item.map((img, index2) => (
                    <img
                      src={finalImagePath(cert, getCertsImagePath(img, cert))}
                      className={sameCoverImage(img, cert) ? styles['img-active'] : styles.img}
                      onClick={() => toggleCoverImg(img, index1, index2)}
                    />
                  ))}
                </div>
              </Swiper.Item>
            ))}
          </Swiper>
          <div className={styles.down} onClick={() => ref.current?.swipeNext()}>
            <DownOutline fontSize={16} color="#333333" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainlandCertShowWrapper
